import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: { marginTop: theme.spacing(1) }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  // divide o nome completo em palavras
  const palavras = sessionStorage.getItem('nomePax').split(' ');

  // pega o primeiro elemento do array resultante, que é o primeiro nome
  const primeiroNome = palavras[0];
  const primeiroNomeFormatado = primeiroNome.charAt(0).toUpperCase() + primeiroNome.slice(1).toLowerCase();

  const user = {
    name: primeiroNomeFormatado,
    avatar: '/images/avatars/avatar_11.png'
  };

  return (
    <div
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user.name}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;